<template>
<div class="drawer-container" :class="{ toggle: modelValue }">
  <template v-if="modelValue">
    <div>
      <div class="drawer-overlay fixed inset-0 z-900 bg-black bg-opacity-30" @click="handleOutsideClick"></div>
      <transition name="drawer-slide">
        <div v-if="modelValue" class="drawer bg-white min-h-screen">
          <div class="p-4 flex justify-between items-center">
            <span><slot name="title">Drawer</slot></span>
            <button type="button" class="btn cursor-pointer transform rotate-45" @click="closeDrawer">
              <img src="@/assets/close-icon.svg" alt="" class="w-4 h-4 opacity-50">
            </button>
          </div>
          <div class="">
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </template>
</div>
</template>

  <script>
  export default {
    name: 'DrawerPanel',
    props: {
      modelValue: {
        type: Boolean,
        required: true
      }
    },
    emits: ['update:modelValue'],
    methods: {
      closeDrawer() {
        this.$emit('update:modelValue', false);
      },
      handleOutsideClick(e) {
        if (e.target.classList.contains('drawer-overlay')) {
          this.closeDrawer();
        }
      }
    }
  }
  </script>

<style scoped>
/* Container */
.drawer-container {
  position: relative;
}

/* Drawer panel */
.drawer {
  position: fixed;
  top: 0;
  left: 0;
  width: 300px;
  z-index: 1000;
  box-shadow: 2px 0 5px rgba(0,0,0,0.1);
  will-change: transform;
}

/* Overlay */
.drawer-overlay {
  z-index: 900;
}

/* Slide for drawer panel */
.drawer-slide-enter-active, .drawer-slide-leave-active {
  transition: transform 0.3s cubic-bezier(.4,0,.2,1);
}
.drawer-slide-enter-from, .drawer-slide-leave-to {
  transform: translateX(-100%);
}
.drawer-slide-enter-to, .drawer-slide-leave-from {
  transform: translateX(0);
}
</style>